import {
    fetchWithSpinner,
    fetchWrapper as fetch
} from 'helpers/fetch'
import { t } from 'helpers/localization'
import { batchActions } from 'redux-batched-actions'
import { closeOldRecommendationsDialog } from './ActionClanProfile'
import { hideDialog } from './ActionDialog'

export const UPDATE_RECOMMENDATIONS_SETTINGS = 'OLD_UPDATE_RECOMMENDATIONS_SETTINGS'
export const UPDATE_SLIDES_IN_SLIDER = 'OLD_UPDATE_SLIDES_IN_SLIDER'
export const UPDATE_CURRENT_SLIDE_INDEX = 'OLD_UPDATE_CURRENT_SLIDE_INDEX'
export const UPDATE_LAST_SLIDE_INDEX_IN_SLIDER = 'OLD_UPDATE_LAST_SLIDE_INDEX_IN_SLIDER'
export const UPDATE_RECOMMENDATIONS_LIST = 'OLD_UPDATE_RECOMMENDATIONS_LIST'
export const TOGGLE_RECOMMENDATIONS_ERROR = 'OLD_TOGGLE_RECOMMENDATIONS_ERROR'
export const TOGGLE_RECOMMENDATIONS_SETTINGS_ERROR = 'OLD_TOGGLE_RECOMMENDATIONS_SETTINGS_ERROR'
export const TOGGLE_RECOMMENDATIONS_SEND_SETTINGS_ERROR = 'OLD_TOGGLE_RECOMMENDATIONS_SEND_SETTINGS_ERROR'
export const TOGGLE_RECOMMENDATIONS_FETCH = 'OLD_TOGGLE_RECOMMENDATIONS_FETCH'
export const TOGGLE_SETTINGS_FETCH = 'OLD_TOGGLE_SETTINGS_FETCH'

export const TOGGLE_RECOMMENDATIONS_CLAN_SETTINGS_FETCH = 'OLD_TOGGLE_RECOMMENDATIONS_CLAN_SETTINGS_FETCH'
export const TOGGLE_RECOMMENDATIONS_CLAN_SETTINGS_ERROR = 'OLD_TOGGLE_RECOMMENDATIONS_CLAN_SETTINGS_ERROR'
export const UPDATE_RECOMMENDATIONS_CLAN_SETTINGS = 'OLD_UPDATE_RECOMMENDATIONS_CLAN_SETTINGS'
export const TOGGLE_RECOMMENDATIONS_CLAN_SEND_SETTINGS_ERROR = 'OLD_TOGGLE_RECOMMENDATIONS_CLAN_SEND_SETTINGS_ERROR'
export const RECOMMENDATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS = 'OLD_RECOMMENDATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS'

export const recommendationsUpdateClanActiveApplications = (clanId, applicationId) => {
    return {
        type: RECOMMENDATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS,
        clanId,
        applicationId,
    }
}

export const updateRecommendationsSettings = (recommendationsSettings) => {
    return {
        recommendationsSettings,
        type: UPDATE_RECOMMENDATIONS_SETTINGS,
    }
}

export const updateSlidesInSlider = (slidesInSlider) => {
    return {
        slidesInSlider,
        type: UPDATE_SLIDES_IN_SLIDER,
    }
}

export const updateCurrentSlideIndex = (currentSlideIndex) => {
    return {
        currentSlideIndex,
        type: UPDATE_CURRENT_SLIDE_INDEX,
    }
}

export const updateLastSlideIndexInSlider = (lastSlideIndexInSlider) => {
    return {
        lastSlideIndexInSlider,
        type: UPDATE_LAST_SLIDE_INDEX_IN_SLIDER,
    }
}

export const updateRecommendationsList = (recommendationsList, isFirstFetch) => {
    return {
        isFirstFetch,
        recommendationsList,
        type: UPDATE_RECOMMENDATIONS_LIST,
    }
}

export const toggleRecommendationsError = (isError, errorMessage) => {
    return {
        isError,
        errorMessage,
        type: TOGGLE_RECOMMENDATIONS_ERROR,
    }
}
export const toggleRecommendationsSettingsError = (isError, errorMessage) => {
    return {
        isError,
        errorMessage,
        type: TOGGLE_RECOMMENDATIONS_SETTINGS_ERROR,
    }
}

export const toggleRecommendationsSendSettingsError = (isError, errorMessage) => {
    return {
        isError,
        errorMessage,
        type: TOGGLE_RECOMMENDATIONS_SEND_SETTINGS_ERROR,
    }
}

export const toggleRecommendationsFetch = (isFetching) => {
    return {
        isFetching,
        type: TOGGLE_RECOMMENDATIONS_FETCH,
    }
}

export const toggleSettingsFetch = (isSettingsFetching) => {
    return {
        isSettingsFetching,
        type: TOGGLE_SETTINGS_FETCH,
    }
}

export const fetchRecommendationsList = () => {
    return function (dispatch, getState) {
        dispatch(toggleRecommendationsFetch(true))
        const state = getState()

        const promise = fetch(state.urls.recommendationsClans)
            .then((recommendationsList) => {
                if (recommendationsList.errors || recommendationsList.error) {
                    dispatch(batchActions([
                        toggleRecommendationsFetch(false),
                        toggleRecommendationsError(true, t('Произошла ошибка. Повторите попытку позже')),
                    ]))
                } else {
                    dispatch(batchActions([
                        toggleRecommendationsFetch(false),
                        updateRecommendationsList(recommendationsList.data, true),
                        toggleRecommendationsError(false, ''),
                    ]))
                }
            })
            .catch(() => {
                dispatch(batchActions([
                    toggleRecommendationsFetch(false),
                    toggleRecommendationsError(true, t('Произошла ошибка. Повторите попытку позже')),
                ]))
            })

        return fetchWithSpinner(dispatch, promise)
    }
}

export const fetchRecommendationsSettings = () => {
    return function (dispatch, getState) {
        dispatch(toggleSettingsFetch(true))

        const state = getState()

        const promise = fetch(state.urls.recommendationsAccountSettings)
            .then((recommendationsSettings) => {
                if (recommendationsSettings.errors || recommendationsSettings.error) {
                    dispatch(batchActions([
                        toggleSettingsFetch(false),
                        toggleRecommendationsSettingsError(true, t('Произошла ошибка. Повторите попытку позже')),
                    ]))
                } else {
                    recommendationsSettings.data.battle_types.sort()
                    recommendationsSettings.data.languages.sort()

                    dispatch(batchActions([
                        updateRecommendationsSettings(recommendationsSettings.data),
                        toggleRecommendationsSettingsError(false, ''),
                        toggleSettingsFetch(false),
                    ]))
                }
            })
            .catch(() => {
                dispatch(batchActions([
                    toggleSettingsFetch(false),
                    toggleRecommendationsSettingsError(true, t('Произошла ошибка. Повторите попытку позже')),
                ]))
            })

        return fetchWithSpinner(dispatch, promise)
    }
}

export const sendRecommendationsSettings = (settings) => {
    return function (dispatch, getState) {
        const state = getState()

        return fetch(state.urls.recommendationsAccountSettings, {
            method: 'PUT',
            body: {
                languages: settings.languages,
                battle_types: settings.battle_types,
            },
        }).then((res) => {
            if (res.errors || res.error) {
                dispatch(toggleRecommendationsSendSettingsError(true, t('Произошла ошибка. Повторите попытку позже')))
            } else {
                dispatch(batchActions([
                    hideDialog(),
                    closeOldRecommendationsDialog(),
                    toggleRecommendationsSendSettingsError(false, ''),
                ]))

                dispatch(fetchRecommendationsList())
            }
        }).catch(() => {
            dispatch(toggleRecommendationsSendSettingsError(true, t('Произошла ошибка. Повторите попытку позже')))
        })
    }
}


export const toggleRecommendationsClanSettingsFetch = (isRecommendationsClanSettingsFetching) => {
    return {
        isRecommendationsClanSettingsFetching,
        type: TOGGLE_RECOMMENDATIONS_CLAN_SETTINGS_FETCH,
    }
}

export const toggleRecommendationsClanSettingsError = (isRecommendationsClanSettingsError, errorRecommendationsClanSettingsMessage) => {
    return {
        isRecommendationsClanSettingsError,
        errorRecommendationsClanSettingsMessage,
        type: TOGGLE_RECOMMENDATIONS_CLAN_SETTINGS_ERROR,
    }
}

export const updateRecommendationsClanSettings = (recommendationsClanSettings) => {
    return {
        recommendationsClanSettings,
        type: UPDATE_RECOMMENDATIONS_CLAN_SETTINGS,
    }
}

export const fetchRecommendationsClanSettings = () => {
    return function (dispatch, getState) {
        dispatch(toggleRecommendationsClanSettingsFetch(true))

        const state = getState()

        const promise = fetch(state.urls.recommendationsClanSettings)
            .then((recommendationsClanSettings) => {
                if (recommendationsClanSettings.errors || recommendationsClanSettings.error) {
                    dispatch(batchActions([
                        toggleRecommendationsClanSettingsFetch(false),
                        toggleRecommendationsClanSettingsError(true, t('Произошла ошибка. Повторите попытку позже')),
                    ]))
                } else {
                    recommendationsClanSettings.data.battle_types.sort()
                    recommendationsClanSettings.data.cvc_game_days.sort()
                    recommendationsClanSettings.data.languages.sort()

                    dispatch(batchActions([
                        updateRecommendationsClanSettings(recommendationsClanSettings.data),
                        toggleRecommendationsClanSettingsError(false, ''),
                        toggleRecommendationsClanSettingsFetch(false),
                    ]))
                }
            })
            .catch(() => {
                dispatch(batchActions([
                    toggleRecommendationsClanSettingsFetch(false),
                    toggleRecommendationsClanSettingsError(true, t('Произошла ошибка. Повторите попытку позже')),
                ]))
            })

        return fetchWithSpinner(dispatch, promise)
    }
}

export const toggleRecommendationsClanSendSettingsError = (isRecommendationsClanSendSettingsError, recommendationsClanSendSettingsErrorMessage) => {
    return {
        isRecommendationsClanSendSettingsError,
        recommendationsClanSendSettingsErrorMessage,
        type: TOGGLE_RECOMMENDATIONS_CLAN_SEND_SETTINGS_ERROR,
    }
}

export const sendRecommendationsClanSettings = (settings) => {
    return function (dispatch, getState) {
        const state = getState()

        return fetch(state.urls.recommendationsClanSettings, {
            method: 'PUT',
            body: {
                languages: settings.languages,
                battle_types: settings.battle_types,
                cvc_game_days: settings.cvc_game_days,
                is_recommendable: settings.is_recommendable,
            },
        }).then((res) => {
            if (res.errors || res.error) {
                dispatch(toggleRecommendationsClanSendSettingsError(true, t('Произошла ошибка. Повторите попытку позже')))
            } else {
                dispatch(batchActions([
                    hideDialog(),
                    closeOldRecommendationsDialog(),
                    toggleRecommendationsClanSendSettingsError(false, ''),
                ]))
            }
        }).catch(() => {
            dispatch(toggleRecommendationsClanSendSettingsError(true, t('Произошла ошибка. Повторите попытку позже')))
        })
    }
}